import React from 'react';
import { RootineTabs } from '../../../atoms/RootineTabs';
import { colors, theme } from '../../../utils/theme';
import { StressRecommendations } from './StressRecommendations';
import { HormoneSnapshot, ResultType } from '../../../types';
import { StressData } from '../../../views/StressInsights';
import { StressProgress } from './StressProgress';

export const RecommendationAndProgressTabs = ({
  stressDataMap,
  snapshots,
}: {
  stressDataMap: Record<ResultType, StressData>;
  snapshots: HormoneSnapshot[];
}): JSX.Element => {
  const latestSnapshot = snapshots[0];

  return (
    <>
      <RootineTabs
        tabs={{
          'Improvement Plan': (
            <StressRecommendations
              snapShot={latestSnapshot}
              stressDataMap={stressDataMap}
            />
          ),
          'Your Progress': <StressProgress snapshots={snapshots} />,
        }}
        hideTabs={false}
        tabsProps={{
          centered: false,
          variant: 'fullWidth',
        }}
        tabProps={{
          sx: {
            fontSize: { xs: 16, md: 18 },
            textTransform: 'none',
            color: colors.greys.GREY_550,
            fontWeight: theme.typography.light,
            '&.Mui-selected': {
              color: colors.greys.TEXT_BLACK,
              fontWeight: theme.typography.medium,
            },
          },
        }}
      />
    </>
  );
};
